<template>
  <div
    class="dynamic-data-table-edit w-full flex flex-col gap-2 items-center justify-center rounded-2 h-[100px] select-none"
    :style="{ backgroundColor: themeVars.primary6, color: themeVars.primary3, fontFamily: 'var(--font-family)' }"
  >
    <CIcon :color="themeVars.primary4" fa-type="fa-kit" :icon="ComponentIcon.DynamicDataTable" size="36px" />
    <span>{{ t('canvasUI.canvasBuilder.dynamicDataTable.addYourTable') }}</span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import { ComponentIcon } from '@canvas-builder/types/canvas'

const { t } = useI18n()
const themeVars = useThemeVars()
</script>
